import styled from 'styled-components';
import AppCSS from '../../utils/styled';
import { Components } from '../Forms/styled';

export const PromptComponents = {
  Container: styled(Components.Container)`
    padding: 0;
  `,
  ChatContainer: styled.form`
    display: grid;
    grid-template-columns: 1fr minmax(30%, 350px);
    gap: 16px;
    height: calc(100vh - 70px);
    background-color: ${AppCSS.colors.white};
    width: 100%;
    ${AppCSS.radiuses.default};
    ${AppCSS.boxShadows.block};
    overflow: hidden;
  `,
  ChatWrapper: styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  `,

  PromptContainer: styled.div`
    display: flex;
    flex-direction: column;
    height: calc(100vh - 110px);
    background-color: ${AppCSS.colors.white};
    width: 100%;
    padding: 16px;
    gap: 16px;
    overflow: hidden;
  `,

  MessagesContainer: styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    padding: 16px;
    gap: 12px;
    background-color: ${AppCSS.colors.utility.screenBackground};
  `,
  InputContainer: styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px;
    background-color: ${AppCSS.colors.white};
    border-top: 1px solid ${AppCSS.colors.greys.light};
    flex-shrink: 0;
  `,

  MessageInput: styled.textarea`
    flex: 1;
    min-height: 44px;
    max-height: 120px;
    padding: 12px 16px;
    border: 1px solid ${AppCSS.colors.greys.medium};
    ${AppCSS.radiuses.default};
    ${AppCSS.fonts.label14Regular};
    color: ${AppCSS.colors.black};
    background-color: ${AppCSS.colors.white};
    resize: none;
    outline: none;

    &:focus {
      border-color: ${AppCSS.colors.blues.primary};
    }

    &::placeholder {
      color: ${AppCSS.colors.greys.medium};
    }
  `,

  SendButton: styled.button.attrs({
    type: 'submit',
  })`
    ${AppCSS.buttonStyles.PrimaryButtonStyle};
    min-width: 80px;
    height: 44px;
    ${AppCSS.radiuses.default};
    ${AppCSS.fonts.label14Regular};

    &:hover {
      background-color: ${AppCSS.colors.blues.primary};
    }

    &:disabled {
      background-color: ${AppCSS.colors.greys.medium};
      cursor: not-allowed;
    }
  `,

  PromptLabel: styled.label`
    ${AppCSS.fonts.label14Bold};
    color: ${AppCSS.colors.black};
    margin-bottom: 8px;
    display: block;
  `,

  PromptTextarea: styled.textarea`
    width: 100%;
    height: 120px; /* Approximately 5 lines */
    padding: 12px 16px;
    border: 1px solid ${AppCSS.colors.greys.medium};
    ${AppCSS.radiuses.default};
    ${AppCSS.fonts.label14Regular};
    color: ${AppCSS.colors.black};
    background-color: ${AppCSS.colors.white};
    resize: vertical;
    outline: none;
    line-height: 1.4;
    font-family: inherit;

    &:focus {
      border-color: ${AppCSS.colors.blues.primary};
    }

    &::placeholder {
      color: ${AppCSS.colors.greys.medium};
    }
  `,

  TemperatureContainer: styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
  `,

  TemperatureLabel: styled.label`
    ${AppCSS.fonts.label14Bold};
    color: ${AppCSS.colors.black};
  `,

  TemperatureInput: styled.input`
    width: 100%;
    height: 44px;
    padding: 12px 16px;
    border: 1px solid ${AppCSS.colors.greys.medium};
    ${AppCSS.radiuses.default};
    ${AppCSS.fonts.label14Regular};
    color: ${AppCSS.colors.black};
    background-color: ${AppCSS.colors.white};
    outline: none;

    &:focus {
      border-color: ${AppCSS.colors.blues.primary};
    }

    &::placeholder {
      color: ${AppCSS.colors.greys.medium};
    }
  `,

  HelperText: styled.span`
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.greys.medium};
  `,

  NewChatButton: styled.button`
    ${AppCSS.buttonStyles.SecondaryButtonStyle};
    ${AppCSS.radiuses.default};
    width: fit-content;
    padding: 8px 16px;

    &:hover {
      background-color: ${AppCSS.colors.blues.veryLight};
    }
  `,
};
